module.exports = __webpack_public_path__ + "static/media/home_background_test_2.ab20d92f.png";